import { render, staticRenderFns } from "./customer-risk-dialog-form.vue?vue&type=template&id=809a715c&scoped=true&"
import script from "./customer-risk-dialog-form.vue?vue&type=script&lang=js&"
export * from "./customer-risk-dialog-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809a715c",
  null
  
)

export default component.exports